import apiClient from './apiClient.js';

export const login = (credentials) => apiClient.post('/auth/login', credentials);

export const adminLogin = (credentials) =>
  apiClient.post('/auth/admin/login', credentials);

export const register = (data) => apiClient.post('/auth/register', data);

export const verifyEmailOtp = ({ email, otp }) =>
  apiClient.post('/auth/verify-email-otp', { email, otp });

export const resendEmailOtp = ({ email }) =>
  apiClient.post('/auth/resend-email-otp', { email });

export const forgotPassword = (email) =>
  apiClient.post('/auth/forgot-password', { email });

export const resetPassword = (data) => apiClient.post('/auth/reset-password', data);
export const me = () => apiClient.get('/auth/me');
export const logout = () => apiClient.post('/auth/logout');
